import { render, staticRenderFns } from "./StepTwo.vue?vue&type=template&id=8d971dee&scoped=true&"
import script from "./StepTwo.vue?vue&type=script&lang=js&"
export * from "./StepTwo.vue?vue&type=script&lang=js&"
import style0 from "./StepTwo.vue?vue&type=style&index=0&id=8d971dee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d971dee",
  null
  
)

export default component.exports